import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { filter, flatten, isEmpty, map } from 'lodash-es';

/**
 * Takes a form group and looks for validation
 * errors and creates error message string array
 * based upon these errors.
 *
 * @param formGroup input form group
 * @param validationMap a mapping of validation messages to errors
 *
 * @example `validationToErrorMessages(myForm, {
 *   'firstName': {
 *       'required': 'Your first name is required.'
 *   },
 *   'lastName': {
 *       'required': 'Your last name is required.'
 *   },
 *   'password': {
 *       'required': 'A password is required'
 *   }
 *
 *})
 *`
 */
export const validationToErrorMessages = (formGroup: UntypedFormGroup, validationMap: unknown): Array<string> => {
  const mapped = map(formGroup.controls, (ctrl: UntypedFormControl, ctrlName: string) => {
    if (ctrl.valid) {
      return '';
    }

    const vms = validationMap[ctrlName];
    if (vms === undefined || vms === null) {
      return 'Some entries on your form are invalid';
    }

    return map(ctrl.errors, function(v, k) {
      return vms[k];
    });
  });

  return filter(flatten(mapped), t => !isEmpty(t));
};
